import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import ReactDataGrid from 'components/react-data-grid';
import { EditableDataGridEmptyComponent, EditableDataGridLoadingSpinner } from '../EditableDataGrid/EditableDataGrid';

export default class DetailDataGrid extends Component {
  constructor(props) {
    super(props);
    this.rowGetter = this.rowGetter.bind(this);
    this.createColumns = this.createColumns.bind(this);
    this.getRowMetaData = this.getRowMetaData.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.handleGridSort = this.handleGridSort.bind(this);
    this.state = {
      rows: props.listData,
      columns: props.columns,
      isDragging: false,
    };

    this.row = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listData) {
      this.setState({
        rows: nextProps.listData,
        columns: nextProps.columns,
        isDragging: false,
      });
    }
  }

  rowGetter(rowIndex) {
    if (!this.state.rows[rowIndex]) {
      this.props.queueRequestFor(rowIndex);
      return {};
    }
    return this.state.rows[rowIndex];
  }

  getRowMetaData() {
    return (rowData, column) => {
      return { options: column.options, rowData: rowData };
    };
  }

  onRowClick(idx, row) {
    this.props.onRowClick(idx, row);
  }

  handleGridSort(sortColumn, sortDirection) {
    if (this.props.onGridSort) return this.props.onGridSort(sortColumn, sortDirection);
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
    };
    const rows = sortDirection === 'NONE' ? this.props.listData : this.state.rows.sort(comparer);
    this.setState({ rows: rows });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !nextState.isDragging;
  }

  render() {
    const rowStyle = {
      height: '75px',
    };
    const RowRenderer = createReactClass({
      setScrollLeft: function (scrollBy) {
        this.row.current.setScrollLeft(scrollBy);
      },
      render: function () {
        return (
          <div className="row-wrapper-detail" style={rowStyle}>
            <ReactDataGrid.Row ref={this.row} {...this.props} />
          </div>
        );
      },
    });

    let EmptyGridView = null;
    if (this.props.isLoading && this.props.showSpinnerWhileLoading) {
      EmptyGridView = EditableDataGridLoadingSpinner;
    } else {
      EmptyGridView = EditableDataGridEmptyComponent;
    }

    const { dataid, isLoading, pageText, rowsCount, contentHeight } = this.props;
    const columns = this.createColumns();
    if (!this.props.listData) return <div />;
    return (
      <ReactDataGrid
        columns={columns}
        enableCellSelect={false}
        rowGetter={this.rowGetter}
        onRowClick={this.onRowClick}
        rowRenderer={RowRenderer}
        isLoading={isLoading}
        pageText={pageText}
        rowsCount={rowsCount}
        onGridSort={this.handleGridSort}
        sortColumn={this.props.sortColumn}
        sortDirection={this.props.sortDirection}
        emptyRowsView={EmptyGridView}
        rowHeight={this.props.rowHeight}
        headerRowHeight={this.props.includeHeaderRow ? 50 : 1}
        moveColumn={null}
        findColumn={null}
        dataid={dataid}
        minHeight={contentHeight}
      />
    );
  }

  createColumns() {
    return [
      {
        name: this.props.columnTitle || 'List',
        key: 'reference',
        align: 'left',
        resizable: false,
        sortable: false,
        visible: true,
        formatter: this.props.cellRenderer,
        getRowMetaData: this.props.getRowMetaData ? this.props.getRowMetaData : this.getRowMetaData(),
        width: 0,
        id: 1,
      },
    ];
  }
}

DetailDataGrid.propTypes = {
  entityType: PropTypes.string,
  pageSize: PropTypes.number,
  columns: PropTypes.array,
  initialSortColumn: PropTypes.string,
  initialSortDir: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  cellRenderer: PropTypes.func,
  includeHeaderRow: PropTypes.bool,
};

DetailDataGrid.defaultProps = {
  isLoading: false,
  pageText: 'Items',
  pageSize: 20,
  rowHeight: 50,
  id: 'ws-grid',
  dataid: '',
  initialSortDir: 'ASC',
  className: '',
  onGridSort: null,
  onAddRow: null,
  sortColumn: null,
  sortDirection: null,
  queueRequestFor: () => {},
  onRowClick: () => {},
  onRowDoubleClick: () => {},
  includeHeaderRow: true,
};
